import React, { useState } from "react";
import { IoPersonSharp } from "react-icons/io5";
import { MdOutlineWaterDrop } from "react-icons/md";
import { CiTrash } from "react-icons/ci";

import RoomImage from "../../../assets/images/room-image.jpeg";

const PropertiesCard = ({ name, details, setIsClicked }) => {
  const styles = {
    card: {
      marginTop: "20px",
      width: "95%",
      fontFamily: "Karla, sans-serif",
      backgroundColor: "#ffffff",
      padding: "10px",
      
      borderRadius: "10px",
      boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.28)"
    },
    propertyImage: {
      width: "100%",
      height: "150px",
      objectFit: "cover",
      borderRadius: "10px",
      marginBottom: "10px",
    },
    titlesContainer: {
      marginLeft: "10px",
    },
    titleStyle: {
      fontSize: "18px",
      margin: "0px",
      color: "#333333",
    },
    locationStyle: {
      color: "#d2a679",
      fontSize: "14px",
      marginBottom: "10px",
    },
    detailsContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
      fontSize: "14px",
      color: "#333333",
      marginLeft: "10px",
      width: "90%",
    },
    iconTextStyle: {
      display: "flex",
      alignItems: "center",
    },
  };
  return (
    <div style={styles.card}>
      <img src={RoomImage} alt="room" style={styles.propertyImage} />
      <div style={styles.titlesContainer}>
        <h2 style={styles.titleStyle}>Apartment APT</h2>
        <div style={styles.locationStyle}>Juja</div>
      </div>
      <div style={styles.detailsContainer}>
        <span style={styles.iconTextStyle}>
          <IoPersonSharp fontSize={15} style={{ marginRight: "10px" }} />
          <div className="">50 Tenants</div>
        </span>
        <span style={styles.iconTextStyle}>
          <MdOutlineWaterDrop fontSize={15} style={{ marginRight: "6px" }} />
          30 ksh/unit
        </span>
        <span style={styles.iconTextStyle}>
          <CiTrash fontSize={15} style={{ marginRight: "6px" }} /> 20 ksh
        </span>
      </div>
    </div>
  );
};

export default PropertiesCard;
